import React from 'react';
import Reveal from '@/components/Reveal';
import LeadForm from '@/components/LeadForm';
import { WhatsAppButton, CallButton } from '@/components/CTAButtons';
import { IMAGES } from '@/data/siteData';

const CTAPanel = ({ title = 'Get Price, Floor Plans & Availability', sub = 'Share your details and our team will send you the latest cost sheet, floor plans and current offers for Provident Palm Vista.' }) => (
  <section className="relative py-16 md:py-24 overflow-hidden" data-testid="cta-panel">
    <img src={IMAGES.renderNight} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" loading="lazy" width={362} height={434} />
    <div className="absolute inset-0 bg-palm/90" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <p className="text-xs font-semibold tracking-[0.25em] uppercase text-gold">Enquire Now</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium text-ivory mt-3 leading-[1.1]">{title}</h2>
        <p className="text-sm sm:text-base text-ivory/70 mt-4 leading-relaxed max-w-lg">{sub}</p>
        <div className="flex flex-wrap gap-3 mt-7">
          <WhatsAppButton testid="cta-panel-whatsapp" />
          <CallButton dark testid="cta-panel-call" />
        </div>
        <p className="text-xs text-ivory/50 mt-4">Or call us directly: <span className="text-gold font-semibold">+91 88798 56585</span></p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="bg-ivory rounded-3xl p-6 sm:p-8 shadow-2xl">
          <LeadForm source="enquiry_section" testidPrefix="cta-panel-form" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTAPanel;
